import { useRef, useEffect } from 'react';

export const useAutoFocus = <T extends HTMLElement>() => {
  const autoFocusRef = useRef<T>(null);

  useEffect(() => {

    const focusedElementBefore = document.activeElement;
    const currentRef = autoFocusRef.current;

    const handleIntersect = (entries: IntersectionObserverEntry[]) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && currentRef) {
          currentRef.focus();
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersect, {
      threshold: 0.1
    });

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
      if (focusedElementBefore) {
        (focusedElementBefore as HTMLElement).focus();
      }
    };
  }, []);

  return autoFocusRef;
}; 
